import React, { useState, useEffect } from 'react';
import {
  FormControl,
  FormControlLabel,
  Box,
  Grid,
  // FormLabel,
  RadioGroup,
  Radio,
  // Accordion,
  // AccordionDetails,
  // AccordionSummary,
  Button,
  TablePagination,
  TableCell,
  TableRow,
  TableHead,
  Stack,
  Table,
  TableContainer,
  Paper,
  TableBody,
  Checkbox,
  Dialog,
  IconButton,
  DialogTitle,
  Alert,
  Snackbar,
  DialogContent,
  CircularProgress,
  Backdrop,
  TextField,
  ButtonGroup,
  Typography,
  tooltipClasses,
  styled,
  Tooltip
  // Modal
} from '@mui/material';
import { VscEye } from 'react-icons/vsc';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SubCard from 'ui-component/cards/SubCard';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { BrandingStatusUpdate, BrandListApi, BrandView, DownloadImages } from 'API/Branding';
import { FaImage } from 'react-icons/fa';
import CloseIcon from '@mui/icons-material/Close';
import { LoadingButton } from '@mui/lab';
import DeleteIcon from '@mui/icons-material/Delete';
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DoneIcon from '@mui/icons-material/Done';

const BrandingRequest = () => {
  // const style = {
  //   position: 'absolute',
  //   top: '50%',
  //   left: '50%',
  //   transform: 'translate(-50%, -50%)',
  //   width: '50%',
  //   height: '80vh',
  //   bgcolor: 'background.paper',
  //   border: '2px solid #000',
  //   display: 'flex',
  //   objectFit: 'contain',
  //   boxShadow: 24,
  //   p: 4
  // };
  const CustomWidthTooltip = styled(({ className, ...props }) => <Tooltip {...props} classes={{ popper: className }} />)({
    [`& .${tooltipClasses.tooltip}`]: {
      maxWidth: 150
    }
  });
  const [filters, setFilters] = useState({
    agent_code: '',
    csp_code: '',
    date: '',
    // date: new Date(new Date().setDate(new Date().getDate() - 5)).toISOString().split('T')[0],
    status: 'pending'
  });
  const [IsLoading, setIsLoading] = useState(false);
  const [BranList, setBranList] = useState(false);
  const [Error, setError] = useState(false);
  const [DialogOpen, setDialogOpen] = useState(false);
  const [FilesMap, setFilesMap] = useState([]);
  const [ImageUrl, setImageUrl] = useState(null);
  const [ImageType, setImageType] = useState('');
  const [Success, setSuccess] = useState(false);
  const [CheckData, setCheckData] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [TotalCount, setTotalCount] = useState('');
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value);
    setPage(0);
  };
  const handleInput = (e) => {
    const value = e.target.value;
    e.target.value = value.replace(/[^A-Za-z0-9]/g, '');
  };
  const handleCheckboxToggle = (data) => {
    if (CheckData && CheckData?.branding?.request_id === data?.branding?.request_id) {
      setCheckData(null); // uncheck if same row clicked
    } else {
      setCheckData(data); // set the selected row
    }
  };
  const handleapprove = (data) => {
    if (CheckData && CheckData?.branding && CheckData?.branding?.request_id) {
      BrandingStatusUpdate(CheckData, data, setIsLoading, setSuccess, setError, refuncion);
    } else {
      setError('There is no request id in the list');
    }
  };
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
  };

  const [OpenAlert, setOpenAlert] = useState(false);
  const handleOpenLoading = () => {
    setIsLoading(true);
  };

  const handleCloseLoading = () => {
    setIsLoading(false);
  };

  const handleOpenAlert = () => {
    setOpenAlert(true);
  };

  const handleDownload = (url) => {
    const file_name = 'document';
    {
      url && url.map((data) => DownloadImages(data, file_name, handleOpenAlert, handleOpenLoading, handleCloseLoading));
    }
  };

  const handleDialogOpen = (file) => {

    setFilesMap(file);
    setDialogOpen(true);
  };
  const handleClear = () => {
    setFilters({
      agent_code: '',
      csp_code: '',
      date: '',
      status: 'pending'
    });
  };
  const refuncion = () => {
    setBranList([]);
    BrandListApi(page + 1, rowsPerPage, filters, setIsLoading, setBranList, setError, setTotalCount);
  };
  useEffect(() => {
    setBranList([]);
    BrandListApi(page + 1, rowsPerPage, filters, setIsLoading, setBranList, setError, setTotalCount);
  }, [rowsPerPage, page, filters]);

  return (
    <>
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={IsLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={Success}
        anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
        autoHideDuration={6000}
        onClose={() => setSuccess(false)}
      >
        <Alert onClose={() => setSuccess(false)} severity="success" variant="filled" sx={{ width: '100%' }}>
          {Success}
        </Alert>
      </Snackbar>
      <Snackbar
        open={OpenAlert}
        anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
        autoHideDuration={6000}
        onClose={() => setOpenAlert(false)}
      >
        <Alert onClose={() => setOpenAlert(false)} severity="error" variant="filled" sx={{ width: '100%' }}>
          Something went wrong
        </Alert>
      </Snackbar>
      <Snackbar
        open={Error}
        anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
        autoHideDuration={6000}
        onClose={() => setError(false)}
      >
        <Alert onClose={() => setError(false)} severity="error" variant="filled" sx={{ width: '100%' }}>
          {Error}
        </Alert>
      </Snackbar>
      <SubCard title="Branding Request">
        <Grid container spacing={2} mb={1}>
          <Grid item xl={2} lg={2} md={4} sm={4} xs={12}>
            <Box>
              <FormControl fullWidth>
                <Typography variant="h5" marginBottom={1} sx={{ color: '#20415C' }}>
                  From Date
                </Typography>
                <TextField
                  id="outlined-basic"
                  fullWidth
                  size="small"
                  type="date"
                  variant="outlined"
                  // label="From Date"
                  name="date"
                  value={filters.date}
                  onChange={handleFilterChange}
                  InputLabelProps={{
                    shrink: true // Ensures the label stays above when a value is selected
                  }}
                  inputProps={{
                    max: new Date().toISOString().split('T')[0], // Sets the maximum date to today
                    onKeyDown: (e) => e.preventDefault()
                  }}
                />
              </FormControl>
            </Box>
          </Grid>
          <Grid item xl={2} lg={2} md={4} sm={4} xs={12}>
            <Typography variant="h5" marginBottom={1} sx={{ color: '#20415C' }}>
              Agent code
            </Typography>
            <TextField
              // label="Agent code"
              name="agent_code"
              size="small"
              fullWidth
              value={filters.agent_code}
              onInput={handleInput}
              onChange={handleFilterChange}
            />
          </Grid>
          <Grid item xl={2} lg={2} md={4} sm={4} xs={12}>
            <Typography variant="h5" marginBottom={1} sx={{ color: '#20415C' }}>
              Csp code
            </Typography>
            <TextField
              // label="Csp code"
              name="csp_code"
              size="small"
              fullWidth
              value={filters.csp_code}
              onInput={handleInput}
              onChange={handleFilterChange}
            />
          </Grid>
          <Grid item xl={4} lg={5} md={6} sm={6} xs={12}>
            <FormControl size="small">
              {/* <FormLabel id="demo-row-radio-buttons-group-label">Status</FormLabel> */}
              <Typography variant="h5" marginBottom={1} sx={{ color: '#20415C' }}>
                status
              </Typography>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="status"
                value={filters.status}
                onChange={handleFilterChange}
              >
                <FormControlLabel value="pending" control={<Radio size="small" />} label="Pending" />
                <FormControlLabel value="approved" control={<Radio size="small" />} label="Approved" />
                <FormControlLabel value="rejected" control={<Radio size="small" />} label="Rejected" />
              </RadioGroup>
            </FormControl>
          </Grid>
          <Grid item xl={2} lg={1} md={6} sm={6} xs={12} alignContent={'center'}>
            {/* <Box alignContent={'center'}> */}
            {/* <Button variant="contained" color="secondary" sx={{ marginRight: '10px' }} size="small">
                search
              </Button> */}
            <Button
              variant="contained"
              color="secondary"
              sx={{
                backgroundColor: '#592375',
                color: '#FFFFFF',
                borderRadius: '6px',
                '&:hover': {
                  backgroundColor: '#592375'
                }
              }}
              size="small"
              onClick={handleClear}
            >
              Clear
            </Button>
            {/* <Button startIcon={<RefreshIcon />} variant="outlined" color="primary" onClick={handleClear} sx={{mr:'5px'}}></Button> */}

            {/* </Box> */}
          </Grid>
          {/* <Grid spacing={2} item xl={3}>
            </Grid> */}
        </Grid>
        {/* </SubCard> */}
        {/* </AccordionDetails>
      </Accordion> */}
        {BranList && BranList.length > 0 ? (
          <>
            {CheckData && filters.status === 'pending' && (
              <Grid item xl={4} md={4} lg={6} sm={6} xs={6} display={'flex'} justifyContent={'space-between'} mb={1}>
                <Button
                  variant="contained"
                  startIcon={<DeleteIcon />}
                  fullWidth
                  color="error"
                  sx={{
                    maxWidth: {
                      xs: '35%',
                      sm: '30%',
                      md: '20%',
                      lg: '15%',
                      xl: '15%'
                    }
                  }}
                  onClick={() => handleapprove('rejected')}
                >
                  reject
                </Button>
                <Button
                  color="success"
                  variant="contained"
                  fullWidth
                  startIcon={<DoneIcon />}
                  sx={{
                    maxWidth: {
                      xs: '35%',
                      sm: '30%',
                      md: '20%',
                      lg: '15%',
                      xl: '15%'
                    }
                  }}
                  onClick={() => handleapprove('approved')}
                >
                  apporve
                </Button>
              </Grid>
            )}
            <Paper sx={{ width: '100%' }}>
              <TableContainer
                sx={{
                  maxHeight: 1000,
                  width: '100%',
                  overflowX: 'auto', // Ensure horizontal scrolling
                  '&::-webkit-scrollbar': {
                    width: '8px',
                    height: '8px'
                  },
                  '&::-webkit-scrollbar-track': {
                    backgroundColor: '#f1f1f1'
                  },
                  '&::-webkit-scrollbar-thumb': {
                    backgroundColor: '#888',
                    borderRadius: '8px'
                  },
                  '&::-webkit-scrollbar-thumb:hover': {
                    backgroundColor: '#555'
                  }
                }}
                // className="table-container"
                component={Paper}
              >
                <Table stickyHeader aria-label="sticky table" size="small">
                  <TableHead>
                    <TableRow hover role="checkbox" tabIndex={-1}>
                      <TableCell></TableCell>
                      <TableCell sx={{ color: '#592375' }}>Request ID</TableCell>
                      <TableCell sx={{ color: '#592375' }}>Agent Name</TableCell>
                      <TableCell sx={{ color: '#592375' }}>Agent Code</TableCell>
                      <TableCell sx={{ color: '#592375' }}>CSP Code</TableCell>
                      <TableCell sx={{ color: '#592375' }}>Mobile</TableCell>
                      <TableCell sx={{ color: '#592375' }}>Language</TableCell>
                      <TableCell sx={{ color: '#592375' }}>Price</TableCell>
                      <TableCell sx={{ color: '#592375' }}>Bank Name</TableCell>
                      {/* <TableCell sx={{ color: '#592375' }}>Branding/ID</TableCell> */}
                      <TableCell sx={{ color: '#592375' }}>Remarks</TableCell>
                      <TableCell sx={{ color: '#592375' }}>Photos</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {BranList?.map((row, index) => (
                        <TableRow
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          // onClick={() => handleCheckboxToggle(row)}
                          // sx={{cursor:'pointer'}}
                          key={index}
                        >
                          <Checkbox
                            checked={CheckData && CheckData?.branding?.request_id === row?.branding.request_id}
                            onChange={() => handleCheckboxToggle(row)}
                            sx={{
                              marginTop: '10px',
                              '&.Mui-checked': {
                                color: '#592375',
                                borderRadius: '50%'
                              },
                              '&:hover': {
                                backgroundColor: 'rgba(0, 0, 0, 0.04)'
                              },
                              '&.Mui-disabled': {
                                color: 'action.disabled'
                              }
                            }}
                            size="small"
                            disabled={filters.status === 'approved' || filters.status === 'rejected'}
                          />
                          <TableCell>{row.branding && row.branding.request_id ? row.branding.request_id : '-'}</TableCell>
                          <TableCell>{row.branding && row.branding.agent_name ? row.branding.agent_name : '-'}</TableCell>
                          <TableCell>{row.branding && row.branding.agent_code ? row.branding.agent_code : '-'}</TableCell>
                          <TableCell>{row.csp_code || '-'}</TableCell>
                          <TableCell>{row.mobile || '-'}</TableCell>
                          <TableCell>{row.branding && row.branding.language ? row.branding.language : '-'}</TableCell>
                          <TableCell>
                            {row.branding && row.branding.price ? `₹${Number(row.branding.price).toLocaleString('en-IN')}` : '-'}
                          </TableCell>
                          <TableCell>{row.bank_name || '-'}</TableCell>
                          {/* <TableCell>{row.branding_id || '-'}</TableCell> */}
                          <TableCell sx={{ width: 200, maxWidth: 200, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            <CustomWidthTooltip
                              placement="bottom-start"
                              title={row.branding && row.branding.remarks ? row.branding.remarks : '-'}
                            >
                              {row.branding && row.branding.remarks ? row.branding.remarks : '-'}
                            </CustomWidthTooltip>
                          </TableCell>
                          <TableCell>
                            <ButtonGroup>
                              <Button
                                size="small"
                                color="secondary"
                                onClick={() => handleDialogOpen(row.branding && row.branding.files)}
                                endIcon={<VscEye fontSize="small" />}
                              >
                                View
                              </Button>
                              <Button size="small" color="secondary" onClick={() => handleDownload(row.branding && row.branding.files)}>
                                <FileDownloadOutlinedIcon fontSize="small" />
                              </Button>
                            </ButtonGroup>
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>

              <TablePagination
                sx={{ width: '100%' }}
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={TotalCount}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Paper>
          </>
        ) : (
          <Grid item xl={12} mt={5}>
            <Stack justifyContent="center" alignItems="center">
              <Typography mt={1} variant="h5">
                No data found
              </Typography>
            </Stack>
          </Grid>
        )}
      </SubCard>
      {/*  */}
      <Dialog open={DialogOpen} onClose={() => setDialogOpen(false)} maxWidth="md" fullWidth>
        <DialogTitle variant="h4">
          {ImageUrl ? 'Preview' : 'Documents'}
          <IconButton
            onClick={() => {
              if (ImageUrl) {
                // Close only preview
                setImageUrl('');
                setImageType('');
              } else {
                // Close the dialog fully
                setDialogOpen(false);
              }
            }}
            sx={{ position: 'absolute', right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          {ImageUrl ? (
            // --- Preview Mode (Image or PDF) ---
            <Box sx={{ width: '100%', height: '500px' }}>
              {ImageType === 'pdf' ? (
                <iframe src={ImageUrl} title="PDF Viewer" style={{ width: '100%', height: '100%', border: 'none' }} />
              ) : (
                <img src={ImageUrl} alt="img" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
              )}
            </Box>
          ) : (
            // --- Document List Mode ---
            <Stack spacing={2} sx={{ width: '100%', padding: 2 }}>
              <Grid container spacing={2}>
                {FilesMap?.map((file, index) => (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                    <LoadingButton
                      fullWidth
                      variant="outlined"
                      onClick={() => BrandView(file, setImageUrl, setImageType, () => {}, setIsLoading, setError)}
                      color="secondary"
                      startIcon={<FaImage />}
                      sx={{
                        textTransform: 'none',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                      }}
                      loading={IsLoading}
                    >
                      <Typography noWrap sx={{ maxWidth: '100%' }}>
                        {file
                          ? (() => {
                              const text = file.split('/').pop();
                              return text.length > 30 ? text.slice(20) : text;
                            })()
                          : ''}
                      </Typography>
                    </LoadingButton>
                  </Grid>
                ))}
              </Grid>
            </Stack>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default BrandingRequest;
